const BINARY_CHUNK = 0x8000

function toBase64Url(bytes) {
  let binary = ''

  for (let index = 0; index < bytes.length; index += BINARY_CHUNK) {
    binary += String.fromCharCode.apply(null, bytes.subarray(index, index + BINARY_CHUNK))
  }

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function encodeHandoff(content) {
  const payload = { v: 1, iat: Date.now(), content }

  return toBase64Url(new TextEncoder().encode(JSON.stringify(payload)))
}
